module.exports = __webpack_public_path__ + "img/滤镜拍立得.54c327a1.png";